import * as xlsx from 'xlsx';
import moment from 'moment';

export const excelDownload = (arr, name) => {
  const ws = xlsx.utils.json_to_sheet(arr, { skipHeader: true });
  const wb = xlsx.utils.book_new();

  xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
  xlsx.writeFile(wb, `${name ? name : ''} ${moment().format('YYYY-MM-DD')}.xlsx`);
};
